import { apiClient } from './apiClient';
import { User } from '../types/user';

type LoginResponse = {
  message?: string;
  expires_in_minutes?: number;
  token?: string;
  token_type?: string;
  expires_at?: string | null;
  user?: User;
  remembered?: boolean;
};

type VerifyOtpResponse = {
  token: string;
  token_type: string;
  expires_at: string | null;
  user: User;
  remembered?: boolean;
};

type ProfileResponse = {
  user: User;
};

export const loginWithEmail = (email: string, password: string, rememberMe: boolean = false) => {
  return apiClient<LoginResponse>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password, remember_me: rememberMe }),
  });
};

export const requestEmailOtp = (email: string) => {
  return apiClient<LoginResponse>('/auth/email-otp', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
};

export const verifyEmailOtp = (email: string, otp: string, deviceName: string, rememberMe: boolean = false) => {
  return apiClient<VerifyOtpResponse>('/auth/email-otp/verify', {
    method: 'POST',
    body: JSON.stringify({ email, otp, device_name: deviceName, remember_me: rememberMe }),
  });
};

export const logout = (token: string) => {
  return apiClient<{ message: string }>('/auth/logout', {
    method: 'POST',
    token,
  });
};

export const fetchProfile = async (token: string): Promise<User> => {
  const response = await apiClient<ProfileResponse>('/auth/profile', {
    method: 'GET',
    token,
  });

  return response.user;
};

export const changePassword = (token: string, currentPassword: string, newPassword: string) => {
  return apiClient<{ message: string }>('/auth/change-password', {
    method: 'POST',
    body: JSON.stringify({
      current_password: currentPassword,
      password: newPassword,
      password_confirmation: newPassword,
    }),
    token,
  });
};

